/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useContext } from 'react';
import { UserOutlined } from '@ant-design/icons';
import { Col, MenuProps, Row } from 'antd';
import { Button, Dropdown, Space } from 'antd';
import styles from './styles.module.scss';
import {
  IsAdminContext,
  ProfilePictureContext,
  UserDesignationDataContext,
  UserProfileDataContext,
} from '../../../context';
import styled from 'styled-components';

const handleMenuClick: MenuProps['onClick'] = (e) => {
  if (e.key === '1') {
    window.location.href = '/user/';
  } else if (e.key === '2') {
    localStorage.removeItem('jwt_token');
    window.location.href = '/signin/';
  }
};

const items: MenuProps['items'] = [
  {
    label: 'Log Out',
    key: '2',
    icon: <UserOutlined />,
  },
];

const itemsAdmin: MenuProps['items'] = [
  {
    label: 'My Profile',
    key: '1',
  },
  {
    label: 'Log Out',
    key: '2',
  },
];

const menuProps = {
  items,
  onClick: handleMenuClick,
};

const menuPropsAdmin = {
  items: itemsAdmin,
  onClick: handleMenuClick,
};

const StyledButton = styled(Button)`
  :where(.css-dev-only-do-not-override-1ij74fp).ant-btn {
    padding: 0px;
  }
`;

//user menu component in the topnav
const UserMenu: React.FC = () => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { userProfileData, setUserProfileData } = useContext(
    UserProfileDataContext
  );
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { userDesignationData, setUserDesignationData } = useContext(
    UserDesignationDataContext
  );
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { userProfilePictureData, setUserProfilePictureData } = useContext(
    ProfilePictureContext
  );
  const isAdmin = useContext(IsAdminContext);

  return (
    <Space wrap style={{ float: 'right', padding: '0px', lineHeight: '80px' }}>
      <Dropdown menu={isAdmin === '1' ? menuPropsAdmin : menuProps}>
        <StyledButton
          style={{
            height: '80px',
            marginRight: '20px',
            width: '250px',
            background: '#F2F4FF',
            borderRadius: '0%',
            border: 'none',
          }}
        >
          <Space>
            <Row>
              <Col span={18}>
                {' '}
                <p className={styles.name}>
                  {userProfileData['personal_details']['name'].length > 16
                    ? userProfileData['personal_details']['name'].substring(
                        0,
                        12
                      ) + '...'
                    : userProfileData['personal_details']['name']}
                  <br />
                  <p className={styles.designation}>
                    <span>
                      {userDesignationData['designation']['designation']
                        ? userDesignationData['designation']['designation']
                            .length > 20
                          ? userDesignationData['designation'][
                              'designation'
                            ].substring(0, 15) + '...'
                          : userDesignationData['designation']['designation']
                        : null}
                    </span>
                  </p>
                  <br />
                </p>
              </Col>
              {/* <DownOutlined /> */}
              <Col span={6}>
                <img
                  className={styles.img}
                  src={userProfilePictureData}
                  onError={(e: any) => {
                    e.target.src = '/no_image.png';
                  }}
                />
                {/* <img  className={styles.img} src ={"http://10.5.5.82:8080/api/v1/profile/files/response/63ba85b0b4cd5673ac195699"}/> */}
              </Col>
            </Row>
          </Space>
        </StyledButton>
      </Dropdown>
    </Space>
  );
};

export default UserMenu;
